var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSliderGate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "100px",
    width: "100px",
    fill: "#000000",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 100 100",
    style: {
      enableBackground: "new 0 0 100 100"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M80,30H40.001c-4.178-3.139-9.372-5-15.001-5C11.191,25,0,36.194,0,50c0,13.807,11.191,25,25,25   c5.629,0,10.823-1.86,15.002-5H80c11.045,0,20-8.955,20-20S91.045,30,80,30z M25,70C13.972,70,5,61.027,5,50s8.972-20,20-20   s20,8.973,20,20S36.028,70,25,70z M80,65H45.001C48.14,60.821,50,55.628,50,50s-1.86-10.821-4.999-15H80c8.271,0,15,6.729,15,15   S88.271,65,80,65z M76.768,38.232L88.535,50L76.768,61.768l-3.535-3.535l5.732-5.732H60v-5h18.965l-5.732-5.732L76.768,38.232z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSliderGate);
export default __webpack_public_path__ + "static/media/slider-gate.a7b8f0adf415cc99642c2fc123ee31a1.svg";
export { ForwardRef as ReactComponent };